import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { SeoProps } from './models';

const Seo: FC<SeoProps> = ({ language, pageTitle }) => (
  <Helmet htmlAttributes={{ lang: language }}>
    <title>{pageTitle}</title>
    <meta name="description" content={pageTitle} />
    <link rel="shortcut icon" href="#" />
  </Helmet>
);

export default Seo;
